'use client';
// ui1(2026-10-17 · instr/cl/ui1 3) — 카드 이미지 깨짐 폴백. <img> 가 실패하면(onerror · 수화 전에 이미 실패한 경우는 complete && naturalWidth 0)
//   가장 가까운 카드 루트([data-ds2-card])에 data-noimg 를 달아 «이미지 없는 컴팩트 카드» 와 같은 모양으로 접는다(ds2.css).
//   ⛔ 빈 박스·남색 자리표시를 남기지 않는다. 마크업·속성은 종전 <img> 그대로(SSR HTML 불변 — alt·loading·크기 동일).
import { useEffect, useRef } from 'react';

export interface CardImgProps {
  src: string;
  alt: string;
  title?: string;
  width: number;
  height: number;
  loading: 'eager' | 'lazy';
  /** seo-audit S-8 — 첫 화면 LCP 이미지만 'high'(대표 현장 카드 첫 장). 없으면 속성 생략(종전 HTML 그대로). */
  fetchPriority?: 'high' | 'low';
}

function fold(img: HTMLImageElement | null) {
  const root = img?.closest('[data-ds2-card]');
  if (root && !root.hasAttribute('data-noimg')) root.setAttribute('data-noimg', '');
}

export default function CardImg({ src, alt, title, width, height, loading, fetchPriority }: CardImgProps) {
  const ref = useRef<HTMLImageElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (el && el.complete && el.naturalWidth === 0) fold(el);
  }, [src]);
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img ref={ref} src={src} alt={alt} title={title} width={width} height={height} loading={loading} {...(fetchPriority ? { fetchPriority } : {})} decoding="async" onError={(e) => fold(e.currentTarget)} />
  );
}
